var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditThin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-322-146H38V918h-360z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-306 -34)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    width: 328,
    height: 88,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 0h20a4 4 0 0 1 4 4v80a4 4 0 0 1-4 4h-20V0Z",
    fill: "#A0D8E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.352 36.61a1.094 1.094 0 0 1 1.546 0l3.492 3.492c.427.427.427 1.12 0 1.546l-9.559 9.558a.469.469 0 0 1-.331.138h-3.75c-.604 0-1.094-.49-1.094-1.094v-3.491c0-.29.115-.568.32-.774Zm-1.727 3.053-6.985 6.985a.156.156 0 0 0-.046.11v3.492c0 .086.07.156.156.156h3.556l7.031-7.03-3.712-3.713Zm2.61-2.39a.156.156 0 0 0-.22 0L317.288 39 321 42.712l1.727-1.727a.156.156 0 0 0 .033-.17l-.024-.04-.01-.01Z",
    fill: "#FFF"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditThin);
export default __webpack_public_path__ + "static/media/edit-thin.18da081a.svg";
export { ForwardRef as ReactComponent };